export default (str, data) =>
  str.replace(/{{(.*?)}}/g, (match, token) => (data[token] ? data[token] : ``));
